import React, { Fragment } from 'react';

import './App.css';
import './bootstrap.min.css';

import Footer from './components/Footer';
import KeyproFooter from './components/KeyproFooter';
import Form from './components/Form';

/**
 * Functional component that renders the multi-step form inside a container
 */
function App() {
    return (
        <Fragment>
            <div className="container">
                <Form />
            </div>
            <Footer />
            <KeyproFooter />
        </Fragment>
    );
}

export default App;
